import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Nav } from "./components/Nav";
import { Hero } from "./components/Hero";
import {
    Process,
    Market,
} from "./components/Sections";
import {
    OpeningStatement,
    Thesis,
    Products,
    EnergyComparison,
} from "./components/Manifesto";
import { Team } from "./components/Team";
import { Contact } from "./components/Contact";
import { Newsletter } from "./components/Newsletter";
import { Footer } from "./components/Footer";
import Consulting from "./pages/Consulting";

// Scroll to top OR to hash target on route change (Lenis-aware)
const ScrollHandler = () => {
    const location = useLocation();
    useEffect(() => {
        const lenis = window.__lenis;
        if (location.hash) {
            setTimeout(() => {
                const el = document.getElementById(
                    location.hash.replace("#", "")
                );
                if (!el) return;
                if (lenis) lenis.scrollTo(el, { offset: -10 });
                else el.scrollIntoView({ behavior: "smooth", block: "start" });
            }, 120);
        } else {
            if (lenis) lenis.scrollTo(0, { immediate: true });
            else window.scrollTo({ top: 0, behavior: "instant" });
        }
        // window.__lenis and el are local variables, not external deps
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.pathname, location.hash]);
    return null;
};

const Landing = () => (
    <div className="bg-lavender min-h-screen">
        <Nav />
        <main>
            <Hero />
            <OpeningStatement />
            <Thesis />
            <Products />
            <Process />
            <EnergyComparison />
            <Market />
            <Team />
            <Contact />
            <Newsletter />
        </main>
        <Footer />
    </div>
);

function App() {
    useEffect(() => {
        const lenis = new Lenis({
            duration: 1.1,
            easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
            smoothWheel: true,
        });
        window.__lenis = lenis;
        let raf;
        const loop = (time) => {
            lenis.raf(time);
            raf = requestAnimationFrame(loop);
        };
        raf = requestAnimationFrame(loop);
        return () => {
            cancelAnimationFrame(raf);
            lenis.destroy();
            window.__lenis = null;
        };
        // Lenis, raf, loop are all local — empty array is correct for run-once setup
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className="App">
            <BrowserRouter>
                <ScrollHandler />
                <Routes>
                    <Route path="/" element={<Landing />} />
                    <Route path="/consulting" element={<Consulting />} />
                </Routes>
            </BrowserRouter>
        </div>
    );
}

export default App;
